
















import { Vue, Component, Prop } from 'vue-property-decorator';

import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';

import { fetchMS } from './fetchMS';
import { ParamApi } from './models/ReportesBajasTransito.model';

import PopUpGenerateReports from '../Atenciones/PopUpGeneratedReports.vue';

@Component({ components: { PopUpGenerateReports } })
export default class ReportesBajasTransitoBtnActions extends Vue {
  @Prop({ required: true, default: {} }) paramApi!: ParamApi;
  @Prop({ required: true, default: [] }) dataList!: any[];

  readonly loadingService: LoadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  msgReport: string = '';
  dialogPopUp: boolean = false;

  handleCloseReport() {
    this.dialogPopUp = false;
    this.msgReport = '';
  }

  async getCSV() {
    const { length: count } = this.dataList;
    if (!count) {
      this.$snotify.error('No hay datos disponibles para generar el reporte', {
        timeout: 3000,
      });
      return;
    }
    try {
      const userId: string = JSON.parse(window.localStorage.getItem('user')).id;
      const user = localStorage.getItem('clienteDefecto');
      this.loadingService.showLoading(null, 'getCSV');
      const params = {
        user_id: userId,
        user,
        count,
        ...this.paramApi,
      };
      const result = await fetchMS({
        endpoint: 'export_excel',
        body: { ...params },
      });
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = result.data;
      const cod: number = Number(CODIGO_RESPUESTA);

      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      this.msgReport = MENSAJE_RESPUESTA;
      this.dialogPopUp = true;
    } catch (error) {
      if (error instanceof Error && error.message !== 'Network Error') {
        this.$snotify.error(error.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error inesperado, por favor intente más tarde',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading('getCSV');
    }
  }
}
